module.exports = __webpack_public_path__ + "img/2_136.3c38d827.png";